import React from 'react';
import { Image, StyleSheet, Text, View } from '@react-pdf/renderer';

// Elementos personalizáveis dos relatórios em PDF, compartilhados por FichaRuptura,
// EnsaioCompressao (sequencial) e RelatorioCaminhao:
//  - LogoRelatorio: logo do cliente no cabeçalho (com fallback tracejado);
//  - AssinaturasRodape: assinaturas dos dois usuários vinculados no cadastro da empresa.
// As imagens chegam como data URI base64 (o backend devolve { dataUri } já convertido).

const styles = StyleSheet.create({
  logoImage: {
    objectFit: 'contain',
  },
  logoPlaceholder: {
    border: '0.75pt dashed #999',
    alignItems: 'center',
    justifyContent: 'center',
  },
  placeholderText: {
    fontSize: 5,
    color: '#888',
    textAlign: 'center',
  },
  signatureRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: 40,
  },
  signatureCol: {
    width: 200,
    alignItems: 'center',
  },
  signatureImage: {
    height: 34,
    width: 160,
    objectFit: 'contain',
  },
  signatureSpacer: {
    height: 34,
  },
  signatureLine: {
    width: '100%',
    borderTop: '0.75pt solid #000',
    marginTop: 2,
    paddingTop: 2,
  },
  signatureName: {
    fontSize: 7,
    fontFamily: 'Helvetica-Bold',
    textAlign: 'center',
  },
  signatureRole: {
    fontSize: 6,
    color: '#555',
    textAlign: 'center',
  },
});

// Logo do cliente no cabeçalho do relatório. Sem `src`, mantém o placeholder tracejado.
export function LogoRelatorio({ src, width = 100, height = 60 }) {
  if (src) {
    return <Image src={src} style={[styles.logoImage, { width, height }]} />;
  }
  return (
    <View style={[styles.logoPlaceholder, { width: width * 0.8, height: height * 0.8 }]}>
      <Text style={styles.placeholderText}>Logo do{'\n'}Relatório</Text>
    </View>
  );
}

// Uma coluna de assinatura: imagem (ou espaço em branco) + linha + nome + função.
function ColunaAssinatura({ src, nome, funcao }) {
  return (
    <View style={styles.signatureCol}>
      {src ? (
        <Image src={src} style={styles.signatureImage} />
      ) : (
        <View style={styles.signatureSpacer} />
      )}
      <View style={styles.signatureLine}>
        <Text style={styles.signatureName}>{nome || ' '}</Text>
        <Text style={styles.signatureRole}>{funcao}</Text>
      </View>
    </View>
  );
}

// Bloco de assinaturas do rodapé: `assinaturas` = [{ src, nome }, { src, nome }] (assinantes 1 e 2 da empresa).
export function AssinaturasRodape({ assinaturas = [] }) {
  const [primeira = {}, segunda = {}] = assinaturas;
  return (
    <View style={styles.signatureRow}>
      <ColunaAssinatura src={primeira.src} nome={primeira.nome} funcao="Responsável Técnico" />
      <ColunaAssinatura src={segunda.src} nome={segunda.nome} funcao="Responsável Técnico" />
    </View>
  );
}
